import React from 'react'
import propTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import { Button, LinearProgress } from '@material-ui/core'

import LateralPanel from '../../common/lateralPanel/LateralPanel'
import PanelHeader from '../../common/lateralPanel/PanelHeader'
import SubstituteMaterialForm from './SubstituteMaterialForm'

export const ADD_TITLE = 'Add substitute material'
export const EDIT_TITLE = 'Edit substitute material'

/**
 * Lateral panel hosting the capture form, for both adding and editing.
 *
 * The panel is thin on purpose: it owns the form instance, the title and the confirm action, while
 * the fields and their rules live in the shared form. Editing differs from adding only in its
 * initial values and in what the caller does with the submitted model.
 */
const SubstituteMaterialPanel = (props) => {
	const { onClose, onSave, isSaving, item, fieldError } = props
	const isEditing = !!item
	const { handleSubmit, control, errors, setError } = useForm()

	// A rejection the server attributed to a specific field is surfaced on that field, so the user
	// sees the cause next to what has to change rather than only in a notification that fades.
	React.useEffect(() => {
		if (fieldError && fieldError.name) {
			setError(fieldError.name, 'server', fieldError.message)
		}
	}, [fieldError, setError])

	const onSubmit = (model) => {
		if (onSave) {
			onSave(isEditing ? { ...model, Token: item.Token } : model)
		}
	}

	return (
		<LateralPanel onClose={onClose}>
			<PanelHeader title={isEditing ? EDIT_TITLE : ADD_TITLE} onCloseButtonClick={onClose} />
			<form onSubmit={handleSubmit(onSubmit)} style={{ padding: '1em' }}>
				<SubstituteMaterialForm control={control} errors={errors} initialValues={item} />
				{isSaving && <LinearProgress color='secondary' />}
				<div style={{ marginTop: '1em', display: 'flex', justifyContent: 'flex-end' }}>
					<Button type='submit' variant='outlined' color='primary' disabled={isSaving}>
						{isEditing ? 'Save' : 'Add'}
					</Button>
				</div>
			</form>
		</LateralPanel>
	)
}

SubstituteMaterialPanel.propTypes = {
	/**Closes the panel without saving */
	onClose: propTypes.func.isRequired,
	/**Receives the captured model; the caller decides whether to add or update */
	onSave: propTypes.func.isRequired,
	/**Whether a save is in flight */
	isSaving: propTypes.bool,
	/**Record being edited; absent means the panel is adding */
	item: propTypes.object,
	/**Server rejection attributed to one field: { name, message } */
	fieldError: propTypes.object
}

SubstituteMaterialPanel.defaultProps = {
	isSaving: false,
	item: null,
	fieldError: null,
	onClose: () => console.warn('Callback [onClose] no defined'),
	onSave: () => console.warn('Callback [onSave] no defined')
}

export default SubstituteMaterialPanel
